import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';

import './APSelect.css';

export const InnerSelect = props => {
  const {
    input,
    meta,
    classModifiers,
    customClass,
    info,
    label,
    onSelect,
    showTriangles,
    options,
    ...passedProps
  } = props;

  const baseClasses = getBEMClasses(['ap-select', customClass]);

  return (
    <div
      className={`form-group ${baseClasses('select-wrapper', classModifiers)}`}>
      <label className={`ap--label ${baseClasses('select-label')}`}>
        {label}
      </label>

      {showTriangles ? (
        <div className={baseClasses('triangles-container')}>
          <span className={'triangle-up'} />
          <span className={'triangle-down'} />
        </div>
      ) : (
        ''
      )}

      <select
        className={`form-control ${baseClasses('select')}`}
        {...input}
        {...passedProps}
        onChange={e => {
          if (onSelect) onSelect(e.target.value);
          input && input.onChange(e);
        }}>
        {options.map((i, idx) => {
          return (
            <option
              key={`${idx}-${i.value}`}
              value={i.value}
              disabled={i.disabled}
              selected={i.selected}>
              {i.label}
            </option>
          );
        })}
      </select>

      <small className={`form-text-muted ${baseClasses('select-info')}`}>
        {info}
      </small>
      {meta &&
        meta.dirty &&
        meta.error && (
          <span className={baseClasses('select-error')}>{meta.error}</span>
        )}
    </div>
  );
};

const APSelect = props => (
  <Field name={props.name} component={InnerSelect} {...props} />
);

APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-select',
  classModifiers: '',
  info: '',
  autoFocus: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};

APSelect.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  classes: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.string,
  info: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  autoFocus: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  multiple: PropTypes.bool,
  required: PropTypes.bool
};

export default APSelect;
